import React from 'react';
import './product.css'
import ContactPageDecor from '../../assets/contact-page-decor.svg'
import ProductComponent from '../productComponent/productComponent';
import { PRODUCTS } from '../../common/Constants';

const Product = () => {

    return (
        <div id='product-page' className='product-page'>
            <img className='product-page-decor' src={ContactPageDecor} alt="Logo with title" />
            <p className='first-text-product'>Our Products</p>
            <div className='products-grid'>
                {PRODUCTS.map((p, i) => (
                    <ProductComponent
                        key={i}
                        productLogo={p.productLogo}
                        productName={p.productName}
                        productTitle={p.productTitle}
                        productDescription={p.productDescription}
                        productUrl={p.productUrl}
                    />
                ))}
            </div>
        </div>
    )

}

export default Product
